<template>
    <div class="swj-category-list">
        <div v-if="loading">
            <Spinner/>
        </div>
        <div class="swj-category-list-item" v-for="category in faqCategories" v-else>
            <Category :icon-src="category.iconUrl" :name="category.name" @click="openCategory(category)"></Category>
        </div>
    </div>
</template>

<script>
    import log from "../../../utils/log";
    import Category from "./Category";

    export default {
        name: "List",
        components: {Category},
        computed: {
            faqCategories: {
                get() {
                    return this.$store.state.faqCategories;
                }
            },
            loading: {
                get() {
                    return this.$store.state.loading;
                }
            }
        },
        methods: {
            openCategory(category) {
                this.$communicator.setPageTitle(category.name);
                this.$communicator.trackEvent("click", "FAQPageCategory", category.id);
                this.$router.push({
                    name: "faq_list",
                    params: {
                        categoryId: category.id
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .swj-category-list {
        margin: 20px 0;
        & > .swj-category-list-item {
            margin: 8px 0;
        }
    }

    ul {
        margin-bottom: 10px;
        ::v-deep .list-group-item {
            padding: .75rem 0 !important;
            border-top: 0;
            margin-bottom: 0 !important;
        }
    }
</style>
